import { css } from '@emotion/react';

export const quickFilterItemStyles = {
    root: css({
        border: '1px solid #DAE7FA',
        borderRadius: '8px',
        padding: '13px 10px',
        cursor: 'pointer',
        color: '#004FC6',
        fontWeight: '700',
        fontSize: '10px',
    }),
    active: css({
        backgroundColor: '#004FC6',
        borderColor: '#004FC6',
        color: '#ffffff',
    }),
};
